import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMemberships } from '../actions/membershipActions';
import MembershipCard from '../components/MembershipCard';

export default function Inventory() {
  const dispatch = useDispatch();
  const { items, total, loading } = useSelector(s => s.memberships);
  const [filters, setFilters] = useState({ q: '', bodyStyle: '', fuelType: '', maxPrice: '' });

  useEffect(() => { dispatch(fetchMemberships({ ...filters, limit: 24 })); }, [dispatch, filters]);

  const set = (k) => (e) => setFilters(f => ({ ...f, [k]: e.target.value }));

  return (
    <section className="section">
      <h1>Inventory</h1>
      <div className="filters">
        <input placeholder="Search make, model, keywords" value={filters.q} onChange={set('q')} />
        <select value={filters.bodyStyle} onChange={set('bodyStyle')}>
          <option value="">Any body style</option>
          {['sedan','suv','truck','coupe','convertible','hatchback','wagon','van'].map(b => <option key={b} value={b}>{b}</option>)}
        </select>
        <select value={filters.fuelType} onChange={set('fuelType')}>
          <option value="">Any fuel</option>
          {['gas','diesel','hybrid','electric'].map(b => <option key={b} value={b}>{b}</option>)}
        </select>
        <input type="number" placeholder="Max price" value={filters.maxPrice} onChange={set('maxPrice')} />
      </div>
      <p className="muted">{loading ? 'Loading…' : `${total} membership${total === 1 ? '' : 's'} match.`}</p>
      <div className="grid grid-3">
        {items.map(c => <MembershipCard key={c._id} membership={c} />)}
      </div>
    </section>
  );
}
